import React from 'react';
import Number from './Number';

const Integer = (props) => {
    return <Number {...props} regex={/^[0-9]+$/} />;
};

export default Integer;
